<template>
    <div>
        <b-row>
            <b-col cols="12">
                <div class="solution-steps">
                    <b-tabs pills content-class="mt-4" align="center">
                        <b-tab title="Calculate" @click="emitEvent('reset-shows-props', 'reset-select-product')">
                        </b-tab>
                       <b-tab title="Property" :active="showPropertySelections" @click="emitEvent('show-property-selections')">
                            <PropertySelections />
                        </b-tab>
                        <b-tab title="Unit" :active="showUnitSelections" @click="emitEvent('show-unit-selections')" :disabled="isUnitDisabled">
                            <UnitSelections />
                        </b-tab>
                        <b-tab title="Bank" :active="showBankSelections" @click="emitEvent('show-bank-selections')" :disabled="isBankDisabled">
                            <BankSelections />
                        </b-tab>
                        <b-tab title="Summary"  :active="showSummarySelections" @click="emitEvent('show-summary-selections')">
                            <SelectionsSummary/>
                        </b-tab>
                    </b-tabs>
                </div>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import { Tabs, TabPane } from 'element-ui'
import solutionEventBus from '@/assets/js/EventBus/solutionEventBus.js'
import BankSelections from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerSolutionScenario/PropertySolution/BankSelections.vue'
import UnitSelections from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerSolutionScenario/PropertySolution/UnitSelections'
import PropertySelections from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerSolutionScenario/PropertySolution/PropertySelections'
import SelectionsSummary from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerSolutionScenario/PropertySolution/SelectionsSummary'
import { mapState } from 'pinia'
import { useProductStore } from '@/stores/productStore'

export default {
    props: {
        showBankSelections: Boolean,
        showPropertySelections: Boolean,
        showUnitSelections: Boolean,
        showSummarySelections: Boolean,
    },
    components: {
        BankSelections,
        PropertySelections,
        UnitSelections,
        SelectionsSummary,
        [Tabs.name]: Tabs,
        [TabPane.name]: TabPane,
    },
    computed: {
        ...mapState(useProductStore, ['current_product_data', 'property_draft_products', 'selected_project']),

        isUnitDisabled() {
            return !this.current_product_data || !this.current_product_data.unit
        },

        isBankDisabled() {
            return !this.selected_project || this.selected_project.project_stage_id === 4
        },
    },
    methods: {
        emitEvent(...eventNames) {
            eventNames.forEach(eventName => {
                solutionEventBus.$emit(eventName)
            })
        }
    },
}
</script>